import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const PROMO_CODES = ["AUPREADEMO", "DEMO2026"];
